Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineHeight = exports.fontSize = void 0;
var _reactNative = require("react-native-web");
var _getREM = require("../getREM");
var fontSize = exports.fontSize = {
  xxs: (0, _getREM.getREM)(0.625),
  xs: (0, _getREM.getREM)(0.75),
  s: (0, _getREM.getREM)(0.875),
  normal: (0, _getREM.getREM)(1),
  m: (0, _getREM.getREM)(1.125),
  l: (0, _getREM.getREM)(1.375),
  xl: (0, _getREM.getREM)(1.875),
  xxl: (0, _getREM.getREM)(2.375)
};
var lineHeight = exports.lineHeight = {
  xxs: fontSize.xxs * 1.5,
  xs: fontSize.xs * 1.5,
  s: fontSize.s * 1.5,
  normal: fontSize.normal * 1.5,
  m: fontSize.m * 1.5,
  l: fontSize.l * 1.5,
  xl: fontSize.xl * 1.5,
  xxl: fontSize.xxl * 1.5
};
if (_reactNative.Platform.OS === 'web') {
  lineHeight.xxs = '150%';
  lineHeight.xs = '150%';
  lineHeight.s = '150%';
  lineHeight.normal = '150%';
  lineHeight.m = '150%';
  lineHeight.l = '150%';
  lineHeight.xl = '150%';
  lineHeight.xxl = '150%';
}